import React from 'react'
import { AppLayout } from '../../../layouts/app'
import ProfileEdit from './ProfileEdit'

export default function ProfileEditPage() {
  return (
    <AppLayout
      title={{
        messageDescriptor: {
          id: 'page.profile/page.title',
          defaultMessage: 'Profile Edit',
        },
      }}
    >
      <ProfileEdit />
    </AppLayout>
  )
}
